import { render, staticRenderFns } from "./SectionIntro.vue?vue&type=template&id=04fe9ab7&scoped=true&"
import script from "./SectionIntro.vue?vue&type=script&lang=js&"
export * from "./SectionIntro.vue?vue&type=script&lang=js&"
import style0 from "./SectionIntro.vue?vue&type=style&index=0&id=04fe9ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fe9ab7",
  null
  
)

export default component.exports